import { cache } from 'react';

export const cachedFetch = cache(
  async (request: Request, timeoutMs: number = 30000): Promise<Response> => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

    try {
      const response = await fetch(request, {
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(
          `Request failed: ${response.status} ${response.statusText} for ${request.url}`
        );
      }

      return response;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        throw new Error(
          `Request timeout after ${timeoutMs}ms for ${request.url}`
        );
      }
      console.error(`Fetch error for ${request.url}:`, error);
      throw error;
    } finally {
      clearTimeout(timeoutId);
    }
  }
);
